import React, {PureComponent} from 'react';
import ui from "redux-ui";
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import {fetchTasksList} from './TasksData';
import {FetchData} from "../../Common/Data/DataFetcher";
import TasksHeader from './TasksHeader.jsx';
import CreateUpdateTask from "./CreateUpdateTask.jsx";
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Add from 'housecall-ui/dist/IconsAndImages/Icons/Add'
import {CLOSE_CREATE_UPDATE_TASK, TASK_SELECTED} from "./Redux/Actions";
import TasksList from "./TasksList.jsx";
import Divider from "housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider"

const styles = {
    createButton: {
        width: '100%',
        textTransform: 'none'
    }
}

@ui({
    state: {
        createUpdateOpen: false,
        task: {},
        showMyTasks: false
    },
    reducer: (state, action) => {
        switch (action.type) {
            case CLOSE_CREATE_UPDATE_TASK:
                return state.set('createUpdateOpen', false)
                    .set('task', {})
            case TASK_SELECTED:
                return state.set('task', action.task)
                    .set('createUpdateOpen', true)
        }
        return state;
    }
})
@withStyles(styles)
@FetchData(fetchTasksList, false)
export default class TasksBar extends PureComponent {

    taskListToggled() {
        this.props.updateUI('showMyTasks', !this.props.ui.showMyTasks)
    }

    render() {

        const {classes, ui} = this.props

        let content = null

        if (ui.createUpdateOpen === true) {
            content = <CreateUpdateTask create={true} task={ui.task}/>
        } else {
            content = (
                <Grid container direction='column' wrap='nowrap' spacing={8}>
                    <Grid item>
                        <TasksHeader
                            toggleTasksDrawer={this.props.toggleTasksDrawer}
                            showMyTasks={this.props.ui.showMyTasks}
                            taskListToggled={() =>{
                                this.taskListToggled()
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Divider/>
                    </Grid>
                    <Grid item>
                        <Button classes={{root: classes.createButton}}
                                onClick={() => {
                                    this.props.updateUI('task', {})
                                    this.props.updateUI('createUpdateOpen', true)
                                }}>
                            <Grid container alignItems='center' spacing={8}>
                                <Grid item style={{margin: 5}}>
                                    <Add/>
                                </Grid>
                                <Grid item>
                                    <Typography variant='subtitle1'>
                                        New task
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Button>
                    </Grid>
                    <TasksList showMyTasks={this.props.ui.showMyTasks}/>
                </Grid>
            )
        }

        return content
    }

}
